<template>
    <div class="custom-control custom-switch">
        <input 
			type="checkbox" 
			class="custom-control-input" 
			:id="identifier" 
			:disabled="disabled"  
			v-model="localValue"
		>
        <label class="custom-control-label" :for="identifier">
			<slot></slot>
		</label>
    </div>
</template>

<script>
    export default {
        props:{
			value: {
            	type: Boolean, 
            	
			},
			disabled: {
            	type: Boolean,
            	default: false
			},
			identifier:{
				type: String,
				default: "customSwitch1"
			}
		  
		},
		data: function(){
			return{
				localValue: this.value
			}		
		},
		watch:{
			localValue (newValue) {
		       this.$emit('input', newValue)
			},
			value (newValue) {
       			this.localValue = newValue
     		}
		},
		methods:{  
			/*handleClick: function (i) {
				this.selected = i
				this.open = !this.open
				this.$emit('change', this.options[i]) 
			}*/
		},
		computed: {
        	isActive() {
        	    return this.currentState;
        	},
        	/*checkedValue: {
        	    get() {
        	        return this.defaultState
        	    },
        	    set(newValue) {
            		this.currentState = newValue;
            		this.$emit('input', newValue);
       			}
			}*/
			
    	}
	
    }
</script>

<style lang="scss" scoped>

</style>